import { ReactElement } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { Autocomplete, TextField } from '@mui/material'
import type { Auth0UserDTO } from '@api/fastAPI.schemas'
import type { FormValues } from '../../types'

const auth0UserLabel = (user: Auth0UserDTO): string => {
  if (user.name && user.email) return `${user.name} (${user.email})`

  return user.email || user.name || user.id
}

interface Auth0UserFieldProps {
  users: Auth0UserDTO[]
  loading: boolean
}

const Auth0UserField = ({ users, loading }: Auth0UserFieldProps): ReactElement => {
  const { control, setValue } = useFormContext<FormValues>()
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name: 'selectedUser', control })

  return (
    <Autocomplete
      options={users}
      value={value}
      loading={loading}
      onChange={(_, user) => {
        onChange(user)
        setValue('name', user?.name || '', { shouldDirty: true })
      }}
      getOptionLabel={auth0UserLabel}
      isOptionEqualToValue={(option, currentValue) => option.id === currentValue.id}
      size="small"
      renderInput={params => (
        <TextField
          {...params}
          label="Auth0-Benutzer"
          error={Boolean(error)}
          helperText={error?.message}
          data-cy="select-auth0-user"
        />
      )}
      noOptionsText="Keine nicht zugewiesenen Auth0-Benutzer"
    />
  )
}

export default Auth0UserField
